module.exports = __webpack_public_path__ + "img/posteco.ab54c2fb.jpeg";